import { render, staticRenderFns } from "./TaskComplete.vue?vue&type=template&id=473b5685&scoped=true"
import script from "./TaskComplete.vue?vue&type=script&lang=js"
export * from "./TaskComplete.vue?vue&type=script&lang=js"
import style0 from "./TaskComplete.vue?vue&type=style&index=0&id=473b5685&prod&lang=scss&scoped=true"
import style1 from "./TaskComplete.vue?vue&type=style&index=1&id=473b5685&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473b5685",
  null
  
)

export default component.exports